var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowPresets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 47C39.8366 47 47 39.8366 47 31C47 22.1634 39.8366 15 31 15C22.1634 15 15 22.1634 15 31C15 39.8366 22.1634 47 31 47ZM32.5433 31.5015C32.134 31.9098 31.5788 32.1392 30.9998 32.1392C30.4209 32.1392 29.8657 31.9098 29.4563 31.5015C29.2536 31.2994 29.0929 31.0593 28.9832 30.7952C28.8735 30.531 28.817 30.2479 28.817 29.962C28.817 29.9456 28.8194 29.93 28.8219 29.9143C28.8244 29.8983 28.8269 29.8822 28.8269 29.865C29.1166 29.97 29.4302 29.9903 29.7311 29.9236C30.0319 29.857 30.3075 29.7062 30.5254 29.4888C30.7433 29.2714 30.8946 28.9966 30.9614 28.6965C31.0282 28.3964 31.0078 28.0836 30.9026 27.7947C30.9172 27.7939 30.9312 27.7919 30.9452 27.7899C30.963 27.7873 30.9808 27.7848 30.9998 27.7848C31.5788 27.7848 32.134 28.0142 32.5433 28.4225C32.9527 28.8308 33.1827 29.3846 33.1827 29.962C33.1827 30.5394 32.9527 31.0932 32.5433 31.5015ZM30.9998 24.519C35.1926 24.519 38.8543 26.9544 40.704 30.5539C40.782 30.7079 40.8226 30.8779 40.8226 31.0504C40.8226 31.2229 40.782 31.393 40.704 31.5469C38.8554 35.1451 35.1926 37.5823 30.9998 37.5823C26.8071 37.5823 23.1454 35.1468 21.2957 31.5473C21.2177 31.3933 21.1771 31.2233 21.1771 31.0508C21.1771 30.8783 21.2177 30.7082 21.2957 30.5543C23.1443 26.9561 26.8071 24.519 30.9998 24.519ZM33.4253 26.3414C32.7074 25.863 31.8633 25.6076 30.9998 25.6076C29.8424 25.6088 28.7327 26.068 27.9142 26.8843C27.0958 27.7007 26.6354 28.8075 26.6342 29.962C26.6342 30.8232 26.8902 31.6651 27.3699 32.3812C27.8496 33.0973 28.5314 33.6554 29.3292 33.985C30.1269 34.3145 31.0047 34.4008 31.8515 34.2328C32.6984 34.0647 33.4763 33.65 34.0869 33.041C34.6974 32.4321 35.1132 31.6562 35.2816 30.8115C35.4501 29.9668 35.3636 29.0913 35.0332 28.2956C34.7028 27.5 34.1432 26.8199 33.4253 26.3414ZM22.2685 31.0506C23.9922 34.4079 27.3381 36.4936 30.9998 36.4936C34.6616 36.4936 38.0078 34.4079 39.7312 31.0506C38.7618 29.1523 37.2114 27.6113 35.3048 26.6509C36.0166 27.5701 36.457 28.7091 36.457 29.962C36.457 31.4056 35.882 32.79 34.8586 33.8108C33.8352 34.8316 32.4472 35.405 30.9998 35.405C29.5525 35.405 28.1645 34.8316 27.1411 33.8108C26.1177 32.79 25.5427 31.4056 25.5427 29.962C25.5427 28.7091 25.9831 27.5701 26.6949 26.6509C24.7883 27.6113 23.2379 29.1523 22.2685 31.0506Z",
    fill: "white",
    fillOpacity: 0.88
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPresets);
export default __webpack_public_path__ + "static/media/show-presets.507ae56b9551256076713bdbebacd7d6.svg";
export { ForwardRef as ReactComponent };